import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

/**
 * Three-state theme toggle. Persists in localStorage via next-themes.
 * Renders server-side neutral until mounted to avoid hydration mismatch.
 */
export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const current = mounted ? (theme === 'system' ? resolvedTheme : theme) : 'dark';

  return (
    <button
      type="button"
      aria-label={`Theme: ${current}. Click to switch.`}
      onClick={() => setTheme(current === 'dark' ? 'light' : 'dark')}
      className={cn(
        'inline-flex h-10 w-10 items-center justify-center rounded-md text-fg-muted transition-colors',
        'hover:bg-bg-subtle hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500',
      )}
    >
      <Sun
        className={cn(
          'h-5 w-5 transition-all duration-base',
          mounted && current === 'dark' ? 'rotate-90 scale-0' : 'rotate-0 scale-100',
        )}
      />
      <Moon
        className={cn(
          '-ml-5 h-5 w-5 transition-all duration-base',
          mounted && current === 'dark' ? 'rotate-0 scale-100' : '-rotate-90 scale-0',
        )}
      />
    </button>
  );
}